// This file contains variables for different themes

export const light = {
  body: "#fafaf9", // 柔和的米白色背景，减少刺眼感
  text: "#826DFB", // purple shade
  bodyRgba: "250, 250, 249",
  textRgba: "130, 109, 251",

  carouselColor: "#EEEDDE",

  fontxs: "0.75em",
  fontsm: "0.875em",
  fontmd: "1em", // 1em = 16px
  fontlg: "1.25em",
  fontxl: "2em",
  fontxxl: "3em",
  fontxxxl: "4em",

  fontButton: "0.875em",

  navHeight: "5rem",
};

export const dark = {
  body: "#0f0f0f",
  text: "#9f7aea", // lighter purple for better contrast in dark mode
  bodyRgba: "15, 15, 15",
  textRgba: "159, 122, 234",

  carouselColor: "#2a2a2a",

  fontxs: "0.75em",
  fontsm: "0.875em",
  fontmd: "1em", // 1em = 16px
  fontlg: "1.25em",
  fontxl: "2em",
  fontxxl: "3em",
  fontxxxl: "4em",

  fontButton: "0.875em",

  navHeight: "5rem",
};
